// Central hotkey config and formatter
const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.platform);
// Treat obvious mobile user-agents as touch-only devices; avoid hiding shortcuts on touch-capable desktops
let isTouch = false;
try {
  if (typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string') {
    isTouch = /Mobi|Android|iPhone|iPad|iPod/.test(navigator.userAgent);
  }
} catch (err) { isTouch = false; }

// Map canonical action keys (labels or ids) to shortcut strings using Mod/Shift/Alt notation
export const HOTKEYS = {
  'Undo': 'Mod+Z',
  'Redo': 'Mod+Shift+Z',
  'Bold': 'Mod+B',
  'Italic': 'Mod+I',
  'Underline': 'Mod+U',
  // future: add other app-wide shortcuts here (New Document, Save, etc.)
};

// Headers H1..H6 and display forms "Header 1" etc
['1','2','3','4','5','6'].forEach((n, i) => {
  HOTKEYS[`H${n}`] = `Mod+Alt+${n}`;
  HOTKEYS[`Header ${n}`] = `Mod+Alt+${n}`;
});

// Strikethrough
HOTKEYS['Strike'] = 'Mod+Shift+X';

// Lists
HOTKEYS['Bullet List'] = 'Mod+Shift+8';
HOTKEYS['Ordered List'] = 'Mod+Shift+7';

// Returns a plain text display string for the given action label, or null if not applicable (e.g. on touch devices)
export function getShortcutText(label) {
  if (isTouch) return null;
  const raw = HOTKEYS[label];
  if (!raw) return null;
  const parts = raw.split('+').map(p => p.trim());
  const out = parts.map(p => {
    const lower = p.toLowerCase();
    if (lower === 'mod') return isMac ? '⌘' : 'Ctrl';
    if (lower === 'shift') return 'Shift';
    if (lower === 'alt' || lower === 'option') return isMac ? 'Option' : 'Alt';
    return p.toUpperCase();
  });
  return out.join('+');
}

const hotkeysExport = {
  HOTKEYS,
  getShortcutText,
};

export default hotkeysExport;
